import { checkLoginStatus, loginSuccess, logout } from './state/auth/action'
import { selectHasRole, selectHasReportingRole, selectEmployeeRoleList, selectEmployeeId, selectHasAccountingRole } from './state/auth/selector'

export default {
    action: {
        logout,
        checkLoginStatus,
        loginSuccess,
    },
    selector: {
        selectHasRole,
        selectHasReportingRole,
        selectEmployeeRoleList,
        selectEmployeeId,
        selectHasAccountingRole,
    },
}



// WEBPACK FOOTER //
// ./src/modules/security/index.js